import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const getPersonasQueryKey = (teamId: string | null | undefined) => [
  'personas',
  teamId,
];

export const useGetPersonasQuery = (teamId: string | null | undefined) => {
  const { personas } = useAvApi();

  return useQuery({
    queryKey: getPersonasQueryKey(teamId),
    queryFn: async () => {
      if (!teamId) return [];

      const { data } = await personas.getV2TeamsPersonasByTeamId({ teamId });

      return data;
    },
    enabled: !!teamId,
  });
};
